"use strict"

import React, {useEffect} from "react"
import {observer} from "mobx-react"
import moment from "moment"
import {injectIntl} from "react-intl"
import {Container, Box, Grid, Typography} from "@material-ui/core"
import XsTable from "../../global/ui/xsTable/xsTable"
import AllocationsStore from "./allocationsStore"

const columns = [
	{
		Header: "Región",
		width: 50,
		accessor: "region_type_code_ext"
	},
	{
		Header: "Skupina zariadenia",
		width: 75,
		accessor: "devide_group_name_ext"
	},
	{
		Header: "Platnosť od",
		width: 75,
		accessor: "validity_from",
		Cell: (props) => <div>{isNotEmpty(props.value) ? moment(props.value).format("DD.MM.YYYY HH:mm") : ""}</div>
	},
	{
		Header: "Štart",
		width: 75,
		accessor: "start",
		Cell: (props) => <div>{isNotEmpty(props.value) ? moment(props.value).format("DD.MM.YYYY HH:mm") : ""}</div>
	},
	{
		Header: "Platnosť do",
		width: 75,
		accessor: "validity_to",
		Cell: (props) => <div>{isNotEmpty(props.value) ? moment(props.value).format("DD.MM.YYYY HH:mm") : ""}</div>
	},
	{
		Header: "Registrované",
		width: 80,
		align: "right",
		accessor: "registered",
		Cell: (props) => (
			<div>
				{new Intl.NumberFormat("sk-SK", {style: "currency", currency: "EUR"})
					.format(props.value)
					.replace("€", "")
					.trim()}
			</div>
		)
	},
	{
		Header: "Prijaté",
		width: 80,
		align: "right",
		accessor: "sent",
		Cell: (props) => (
			<div>
				{new Intl.NumberFormat("sk-SK", {style: "currency", currency: "EUR"})
					.format(props.value)
					.replace("€", "")
					.trim()}
			</div>
		)
	},
	{
		Header: "Zazmluvnená",
		width: 80,
		align: "right",
		accessor: "contracted",
		Cell: (props) => (
			<div>
				{new Intl.NumberFormat("sk-SK", {style: "currency", currency: "EUR"})
					.format(props.value)
					.replace("€", "")
					.trim()}
			</div>
		)
	},
	{
		Header: "Uhradené",
		width: 80,
		align: "right",
		accessor: "paid",
		Cell: (props) => (
			<div>
				{new Intl.NumberFormat("sk-SK", {style: "currency", currency: "EUR"})
					.format(props.value)
					.replace("€", "")
					.trim()}
			</div>
		)
	},
	{
		Header: "Zamietnuté",
		width: 80,
		align: "right",
		accessor: "rejected",
		Cell: (props) => (
			<div>
				{new Intl.NumberFormat("sk-SK", {style: "currency", currency: "EUR"})
					.format(props.value)
					.replace("€", "")
					.trim()}
			</div>
		)
	},
	{
		Header: "Späťvzaté",
		width: 80,
		align: "right",
		accessor: "withdrawn",
		Cell: (props) => (
			<div>
				{new Intl.NumberFormat("sk-SK", {style: "currency", currency: "EUR"})
					.format(props.value)
					.replace("€", "")
					.trim()}
			</div>
		)
	},
	{
		Header: "Zostatok alokácie",
		width: 80,
		align: "right",
		accessor: "remaining_allocation",
		Cell: (props) => (
			<div>
				{new Intl.NumberFormat("sk-SK", {style: "currency", currency: "EUR"})
					.format(props.value)
					.replace("€", "")
					.trim()}
			</div>
		)
	},
	{
		Header: "Alokácia",
		width: 80,
		align: "right",
		accessor: "allocation",
		Cell: (props) => (
			<div>
				{new Intl.NumberFormat("sk-SK", {style: "currency", currency: "EUR"})
					.format(props.value)
					.replace("€", "")
					.trim()}
			</div>
		)
	}
]

function AllocationsContainer() {
	useEffect(() => {
		AllocationsStore.getAllocations()
	}, [])

	return (
		<Container maxWidth="lg">
			<Grid container justify="space-between" alignItems="center" className="pt-8">
				<Grid item>
					<Typography variant="h4">Alokácie</Typography>
				</Grid>
			</Grid>
			<Box pt={2}>
				<Grid container>
					<Grid item xs={12}>
						<Box pt={1}>
							<XsTable columns={columns} data={AllocationsStore.data} />
						</Box>
					</Grid>
				</Grid>
			</Box>
		</Container>
	)
}

export default injectIntl(observer(AllocationsContainer))

